import { render } from "./CadastroFinalizacao.vue?vue&type=template&id=62facb59&scoped=true"
import script from "./CadastroFinalizacao.vue?vue&type=script&lang=js"
export * from "./CadastroFinalizacao.vue?vue&type=script&lang=js"

import "./CadastroFinalizacao.vue?vue&type=style&index=0&id=62facb59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62facb59"]])

export default __exports__